<template>
    <MDBCol cols="12" md="5">
        <div class="mb-1"><b>{{ $t('onboarding.tradingPartner') }}...</b></div>
        <div v-for="option in partnerOptions" :key="option.value" class="d-flex">
            <div v-if="option.onlyLabel" class="mb-2">
                <label class="form-check-label" v-html="$t(option.label)"></label>
            </div>
            <div v-else class="d-flex">
                <input :id="`business-partner-${option.value}`" type="radio" class="form-check-input"
                    name="bussinessPartner" :value="option.value" :checked="bussinessPartner === option.value"
                    :disabled="loading" @click="$emit('store', option.value)" />
                <label :for="`business-partner-${option.value}`" class="form-check-label"
                    v-html="$t(option.label)"></label>
            </div>
        </div>
    </MDBCol>
</template>

<script setup>
import { MDBCol } from "mdb-vue-ui-kit";
import { computed, defineProps } from "vue";
const props = defineProps({
    bussinessPartner: String,
    cannotSeeFleet: Boolean,
    cannotSeeBothRelation: Boolean,
    cannotSeeNoBussinessRelation: Boolean,
    canSeeDirectRelation: { type: Boolean, default: true },
    loading: Boolean,
});

const partnerOptions = computed(() => [
    { value: 'tradingPartnerDirect', label: 'onboarding.tradingPartnerDirect', onlyLabel: false, visible: props.canSeeDirectRelation },
    { value: 'tradingPartnerIndirect', label: 'onboarding.tradingPartnerIndirect', onlyLabel: false },
    { value: 'tradingPartnerBoth', label: 'onboarding.tradingPartnerBoth', visible: props.cannotSeeBothRelation, onlyLabel: false },
    { value: 'fleetResponsibleDirect', label: 'onboarding.fleetResponsibleDirect', visible: props.cannotSeeFleet, onlyLabel: true },
    { value: 'fleetResponsibleIndirect', label: 'onboarding.fleetResponsibleIndirect', visible: props.cannotSeeFleet, onlyLabel: false },
    { value: 'fleetResponsibleBoth', label: 'onboarding.fleetResponsibleBoth', visible: props.cannotSeeFleet && props.cannotSeeBothRelation, onlyLabel: false },
    { value: 'noBusinessRelationship', label: 'onboarding.noBusinessRelationship', visible: props.cannotSeeNoBussinessRelation, onlyLabel: false }
].filter(option => option.visible === undefined || option.visible));
</script>